import {AminoConverter} from "@shareledgerjs/amino";

export function createNftAminoConverters(): Record<string, AminoConverter | "not_supported_by_chain"> {
  return {};
}
